export const DEFAULT_DIMENSIONS = { width: 1024, height: 1024 };
